import { initialState } from "../../../store/slice/userAccountSlice";
import store from "../../../store/store";
const _ = require("lodash");

const convertBrokerId = (data) => {
  if (!data) return null;

  const parseBrokerId = (raw) => {
    if (raw === null || raw === undefined) return raw;

    // If it's already a number, return as-is
    if (typeof raw === "number") return raw;

    // If it's an object (e.g. option object), try common fields
    if (typeof raw === "object") {
      if (raw?.userId !== undefined) return Number(raw.userId);
      if (raw?.value !== undefined) return Number(raw.value);
      return raw;
    }

    // If it's a string like "256523 (BHAGVAN DAS)", extract leading digits
    if (typeof raw === "string") {
      const match = raw.match(/^\s*(\d+)/);
      if (match) return Number(match[1]);
      return raw;
    }

    return raw;
  };

  return data?.map((el) => {
    const raw =
      Array.isArray(el?.brokerId) && el?.brokerId?.length > 0
        ? el?.brokerId?.[0]
        : el?.brokerId;

    return {
      ...el,
      brokerId: parseBrokerId(raw),
    };
  });
};
const filterBlockedScript = (data, preBlock) => {
  const unicData = [...new Set(data)];
  const previousBlock = [...new Set(preBlock)];
  const filteredData = unicData
    ?.filter((el) => !previousBlock?.includes(el))
    ?.map((item) => ({ symbol: item, status: "block", blockedBy: "parent" }));
  const updatedData = previousBlock
    ?.filter((el) => !data?.includes(el))
    ?.map((item) => ({ symbol: item, status: "unblock", blockedBy: "parent" }));
  return [...new Set([...filteredData, ...updatedData])];
};

export const payloadObject = ({ value, market, isEdit, isRent, type }) => {
  const blockedScriptList = store.getState()?.scriptSettingsRequestSlice;
  let userSlice = store.getState()?.userAccountSlice;
  if (isEdit) {
    const market_access = userSlice?.market_access;
    let parentAccount = userSlice?.parentValidation;
    let isRents = parentAccount?.accountDetails?.partnershipWith === "rent";

    const isCustomer = userSlice?.accountType === "customer";
    let AdditonalInfo = {};
    for (let key in initialState?.accountDetails?.additionalInfo) {
      if (value[key]) {
        AdditonalInfo[key] = value[key];
      }
    }
    let obj = {
      accountType: userSlice?.accountType,
      authorityLevel: userSlice?.authorityLevel,
      basicInfo: {
        accountName: value?.accountName || "XXYY",
        balance: value?.balance === 0 ? 0 : value.balance || "XXYY",
        accountPassword: value?.accountPassword,
        linkLedger: value?.linkLedger ?? "XXYY",
      },
      accountDetails: {
        allowNoOfAccountSuperAdmin:
          Number(value?.allowNoOfAccountSuperAdmin) === 0
            ? 0
            : Number(value?.allowNoOfAccountSuperAdmin) || "XXYY",
        allowNoOfAccountAdmin:
          Number(value?.allowNoOfAccountAdmin) === 0
            ? 0
            : Number(value?.allowNoOfAccountAdmin) || "XXYY",
        allowNoOfAccountMaster:
          Number(value?.allowNoOfAccountMaster) === 0
            ? 0
            : Number(value?.allowNoOfAccountMaster) || "XXYY",
        allowNoOfAccountBroker:
          Number(value?.allowNoOfAccountBroker) === 0
            ? 0
            : Number(value?.allowNoOfAccountBroker) || "XXYY",
        allowNoOfAccountDealer:
          Number(value?.allowNoOfAccountDealer) === 0
            ? 0
            : value?.allowNoOfAccountDealer || "XXYY",
        allowNoOfAccountCustomer:
          Number(value?.allowNoOfAccountCustomer) === 0
            ? 0
            : Number(value?.allowNoOfAccountCustomer) || "XXYY",
        partnershipWith: value?.partnershipWith || "XXYY",
        minimumBrokerageRequire: value?.minimumBrokerageRequire ?? "XXYY",
        additionalInfo: AdditonalInfo || "XXYY",
        orderBetweenHighLow: value?.orderBetweenHighLow ?? "XXYY",
        showDetailBill: value?.showDetailBill ?? "XXYY",
        allowBannedScript: value?.allowBannedScript ?? "XXYY",
        isOnlyPositionSquareOff: value?.isOnlyPositionSquareOff ?? "XXYY",
        isAutoStopNewPosition: value?.isAutoStopNewPosition ?? "XXYY",
        autoStopNewPosition: {
          profit:
            value?.isAutoStopNewPosition === false
              ? null
              : value?.autoStopNewPosition?.profit !== undefined
              ? value?.autoStopNewPosition?.profit
              : "XXYY",
          loss:
            value?.isAutoStopNewPosition === false
              ? null
              : value?.autoStopNewPosition?.loss !== undefined
              ? value?.autoStopNewPosition?.loss
              : "XXYY",
        },
        isApplyAutoSquareOff: value?.isApplyAutoSquareOff ?? "XXYY",
        applyAutoSquareOff: {
          profit:
            value?.isApplyAutoSquareOff === false
              ? null
              : value?.applyAutoSquareOff?.profit !== undefined
              ? value?.applyAutoSquareOff?.profit
              : "XXYY",
          loss:
            value?.isApplyAutoSquareOff === false
              ? null
              : value?.applyAutoSquareOff?.loss !== undefined
              ? value?.applyAutoSquareOff?.loss
              : "XXYY",
        },
        isM2MAlert: value?.isM2MAlert ?? "XXYY",
        M2MAlert: {
          profit:
            value?.M2MAlert?.profit !== undefined
              ? value?.M2MAlert?.profit
              : "XXYY",
          loss:
            value?.M2MAlert?.loss !== undefined
              ? value?.M2MAlert?.loss
              : "XXYY",
        },
        isNewPositionSquareOffTime: value?.isNewPositionSquareOffTime ?? "XXYY",
        newPositionSquareOffTime: {
          time:
            value?.isNewPositionSquareOffTime === false
              ? null
              : value?.newPositionSquareOffTime !== undefined
              ? value?.newPositionSquareOffTime?.toISOString() || null
              : "XXYY",
          stringTime:
            value?.isNewPositionSquareOffTime === false
              ? null
              : value?.newPositionSquareOffTime !== undefined
              ? `${
                  Number(
                    Number(value?.newPositionSquareOffTime?.format("HH")) * 60
                  ) + Number(value?.newPositionSquareOffTime?.format("mm"))
                }:${value?.newPositionSquareOffTime?.format("ss")}` || null
              : "XXYY",
        },
        isFreshLimitAllow: value?.isFreshLimitAllow ?? "XXYY",
        freshLimitAllow:
          value?.isFreshLimitAllow === false
            ? null
            : value?.freshLimitAllow !== undefined
            ? value?.freshLimitAllow
            : "XXYY",

        remark: value?.remark,
      },
      marketAccess: [],
    };

    if (isRent) {
      obj.basicInfo = {
        ...obj.basicInfo,
        autoLock: value?.autoLock !== undefined ? value?.autoLock : "XXYY",
        isExpiryMessageBeforeDays:
          value?.isExpiryMessageBeforeDays !== undefined
            ? value?.isExpiryMessageBeforeDays
            : "XXYY",
        expiryMessageBeforeDays:
          value?.expiryMessageBeforeDays !== undefined
            ? value?.expiryMessageBeforeDays
            : "XXYY",
        expiryDate:
          value?.expiryDate !== undefined
            ? value?.expiryDate?.toISOString()
            : "XXYY",
        rent: value?.rent !== undefined ? value?.rent : "XXYY",
      };
    }

    if (userSlice?.accountType === "broker") {
      return obj;
    }

    let initalMarket =
      store?.getState()?.globleSlice?.constantValue?.marketAccess;
    const oldSelectedMarket = store
      ?.getState()
      ?.globleSlice?.constantValue?.allMaketAccess?.filter((el) => !el?.status)
      ?.map((el) => el?.scriptName);

    const difference = new Set(_.difference(market, initalMarket));
    let rentMarket = [];
    market.forEach((scriptName) => {
      if (isRent) {
        rentMarket.push({ scriptName: scriptName });
      } else {
        let isOld = oldSelectedMarket?.includes?.(scriptName);
        let isNew = difference.has(scriptName) && !isOld;

        const name =
          scriptName === "NSE EQU" || scriptName === "CRYPTO"
            ? "totalNoOfQuantity"
            : "totalNoOfLot";
        let remainingPercentage = isCustomer
          ? 0
          : userSlice?.accountType === "masterAdmin" || isRents
          ? 100 - value[scriptName]?.percentage
          : parentAccount?.brokarageDetails[scriptName]?.remainingPercentage -
            value[scriptName]?.percentage;
        const brokerageDetails = {
          deliveryTotal:
            value[scriptName]?.deliveryTotal === 0
              ? 0
              : value[scriptName]?.deliveryTotal || (isNew ? 0 : "XXYY"),
          intradayTotal:
            value[scriptName]?.intradayTotal === 0
              ? 0
              : value[scriptName]?.intradayTotal || (isNew ? 0 : "XXYY"),
          deliveryBuy:
            value[scriptName]?.deliveryBuy === 0
              ? 0
              : (isCustomer
                  ? value[scriptName]?.deliveryBuy
                  : value[scriptName]?.deliveryTotal / 2) ||
                (isNew ? 0 : "XXYY"),
          intradayBuy:
            value[scriptName]?.intradayBuy === 0
              ? 0
              : (isCustomer
                  ? value[scriptName]?.intradayBuy
                  : value[scriptName]?.intradayTotal / 2) ||
                (isNew ? 0 : "XXYY"),
          deliverySell:
            value[scriptName]?.deliverySell === 0
              ? 0
              : (isCustomer
                  ? value[scriptName]?.deliverySell
                  : value[scriptName]?.deliveryTotal / 2) ||
                (isNew ? 0 : "XXYY"),
          intradaySell:
            value[scriptName]?.intradaySell === 0
              ? 0
              : (isCustomer
                  ? value[scriptName]?.intradaySell
                  : value[scriptName]?.intradayTotal / 2) ||
                (isNew ? 0 : "XXYY"),
          percentage:
            isCustomer && isNew
              ? isRents
                ? 100
                : parentAccount?.brokarageDetails[scriptName]
                    ?.remainingPercentage
              : value[scriptName]?.percentage === 0
              ? 0
              : value[scriptName]?.percentage || (isNew ? 0 : "XXYY"),
          ...(value?.[scriptName]?.brokerageType && {
            brokerageType: value?.[scriptName]?.brokerageType
              ? value?.[scriptName]?.brokerageType
              : ["NSE OPT", "MCX", "MCX OPT"]?.includes(scriptName)
              ? "fixed"
              : "percentage",
          }),
          ...(isNew && {
            brokerageType: value?.[scriptName]?.brokerageType
              ? value?.[scriptName]?.brokerageType
              : ["NSE OPT", "MCX", "MCX OPT"]?.includes(scriptName)
              ? "fixed"
              : "percentage",
          }),
          remainingPercentage: remainingPercentage || (isNew ? 0 : "XXYY"),
        };

        const additionalSharing =
          convertBrokerId(value[scriptName]?.additionalSharing) || "XXYY";
        const margin = {
          type:
            value[scriptName]?.type === "value"
              ? "value"
              : value[scriptName]?.type?.[0] || (isNew ? "value" : "XXYY"),
          delivery:
            value[scriptName]?.delivery === 0
              ? 0
              : value[scriptName]?.delivery || (isNew ? 0 : "XXYY"),
          intraday:
            value[scriptName]?.intraday === 0
              ? 0
              : value[scriptName]?.intraday || (isNew ? 0 : "XXYY"),
          total:
            value[scriptName]?.total === 0
              ? 0
              : value[scriptName]?.total || (isNew ? 0 : "XXYY"),
          interestRate:
            value[scriptName]?.interestRate === 0
              ? 0
              : value[scriptName]?.interestRate || (isNew ? 0 : "XXYY"),
          deposit:
            value[scriptName]?.deposit === 0
              ? 0
              : value[scriptName]?.deposit || (isNew ? 0 : "XXYY"),
        };
        const scriptWiseSettingInfo = {
          minimumScriptRate:
            value[scriptName]?.minimumScriptRate === 0
              ? 0
              : value[scriptName]?.minimumScriptRate === null
              ? null
              : value[scriptName]?.minimumScriptRate || (isNew ? null : "XXYY"),
          totalNoOfScripts:
            value[scriptName]?.totalNoOfScripts === 0
              ? 0
              : value[scriptName]?.totalNoOfScripts === null
              ? null
              : value[scriptName]?.totalNoOfScripts || (isNew ? null : "XXYY"),
          orderLimits:
            value[scriptName]?.orderLimits === 0
              ? 0
              : value[scriptName]?.orderLimits === null
              ? null
              : value[scriptName]?.orderLimits || (isNew ? null : "XXYY"),
          strikeRateMaxLot:
            value[scriptName]?.strikeRateMaxLot === 0
              ? 0
              : value[scriptName]?.strikeRateMaxLot === null
              ? null
              : value[scriptName]?.strikeRateMaxLot || (isNew ? null : "XXYY"),
          allowShortSell:
            value[scriptName]?.allowShortSell ?? (isNew ? false : "XXYY"),
          allowLimitOrder:
            value[scriptName]?.allowLimitOrder ?? (isNew ? true : "XXYY"),
          allowQuantityTrading:
            value[scriptName]?.allowQuantityTrading ?? (isNew ? false : "XXYY"),
          [name]:
            value[scriptName]?.[name] === 0
              ? 0
              : value[scriptName]?.[name] === null
              ? null
              : value[scriptName]?.[name] || (isNew ? null : "XXYY"),
          circuitFilter:
            value[scriptName]?.circuitFilter === null
              ? 0
              : value[scriptName]?.circuitFilter ?? (isNew ? 0 : "XXYY"),
          highLowPermission:
            value[scriptName]?.highLowPermission ?? (isNew ? false : "XXYY"),
        };
        const isOnlyPositionSquareOff =
          value[scriptName]?.isOnlyPositionSquareOff ??
          (isNew ? false : "XXYY");
        const allScript =
          blockedScriptList?.[scriptName]?.edited || (isNew ? [] : "XXYY");
        const blockScript =
          filterBlockedScript(
            blockedScriptList?.[scriptName]?.blocked,
            blockedScriptList?.[scriptName]?.preBlock
          ) || (isNew ? [] : "XXYY");
        const deletedScript = blockedScriptList?.[scriptName]?.deleted || (isNew ? [] : "XXYY");

        let marketWisePayload = {
          brokerageDetails,
          additionalSharing,
          margin,
          scriptWiseSettingInfo,
          isOnlyPositionSquareOff,
          allScript,
          blockScript,
          deletedScript,
          scriptName: scriptName,
        };
        obj.marketAccess.push(marketWisePayload);
      }
    });

    if (userSlice?.accountType === "broker") {
      obj.marketAccess = parentAccount?.parentMarketList;
    }
    // let deletedMarket = [];
    // for (let a = 0; a < initalMarket.length; a++) {
    //   let check = market_access?.includes(initalMarket?.[a]);
    //   if (!check) {
    //     deletedMarket.push(initalMarket?.[a]);
    //   }
    // }
    // obj.removeMarket = deletedMarket;

    return obj;
  } else {
    let parentAccount = userSlice?.parentValidation;
    let isRents = parentAccount?.accountDetails?.partnershipWith === "rent";

    const isCustomer = userSlice?.accountType === "customer";
    let AdditonalInfo = {};
    for (let key in initialState?.accountDetails?.additionalInfo) {
      if (value[key]) {
        AdditonalInfo[key] = value[key];
      }
    }
    let obj = {
      accountType: userSlice?.accountType,
      authorityLevel: userSlice?.authorityLevel,
      basicInfo: {
        accountName: value?.accountName || "",
        balance: value?.balance || 0,
        accountPassword: value?.accountPassword,
        linkLedger: value?.linkLedger || false,
        openingBalance: value?.openingBalance || 0,
        partnerShipType: type,
      },
      accountDetails: {
        allowNoOfAccountMasterAdmin: 0,
        allowNoOfAccountSuperAdmin:
          Number(value?.allowNoOfAccountSuperAdmin) || 0,
        allowNoOfAccountAdmin: Number(value?.allowNoOfAccountAdmin) || 0,
        allowNoOfAccountMaster: Number(value?.allowNoOfAccountMaster) || 0,
        allowNoOfAccountBroker: Number(value?.allowNoOfAccountBroker) || 0,
        allowNoOfAccountDealer: Number(value?.allowNoOfAccountDealer) || 0,
        allowNoOfAccountCustomer: Number(value?.allowNoOfAccountCustomer) || 0,
        partnershipWith: value?.partnershipWith || null,
        minimumBrokerageRequire: value?.minimumBrokerageRequire || false,
        additionalInfo: AdditonalInfo || {},
        orderBetweenHighLow: value?.orderBetweenHighLow || false,
        showDetailBill: value?.showDetailBill || false,
        allowBannedScript: value?.allowBannedScript || false,
        isOnlyPositionSquareOff: value?.isOnlyPositionSquareOff || false,
        isAutoStopNewPosition: value?.isAutoStopNewPosition || false,
        autoStopNewPosition: {
          profit: value?.autoStopNewPosition?.profit || null,
          loss: value?.autoStopNewPosition?.loss || null,
        },
        isApplyAutoSquareOff: value?.isApplyAutoSquareOff || false,
        applyAutoSquareOff: {
          profit: value?.applyAutoSquareOff?.profit || null,
          loss: value?.applyAutoSquareOff?.loss || null,
        },
        isM2MAlert: value?.isM2MAlert || false,
        M2MAlert: {
          profit: value?.M2MAlert?.profit || null,
          loss: value?.M2MAlert?.loss || null,
        },
        isNewPositionSquareOffTime: value?.isNewPositionSquareOffTime || false,
        newPositionSquareOffTime: {
          time: value?.newPositionSquareOffTime
            ? value?.newPositionSquareOffTime?.toISOString() || null
            : null,
          stringTime: value?.newPositionSquareOffTime
            ? `${
                Number(
                  Number(value?.newPositionSquareOffTime?.format("HH")) * 60
                ) + Number(value?.newPositionSquareOffTime?.format("mm"))
              }:${value?.newPositionSquareOffTime?.format("ss")}`
            : null,
        },
        isFreshLimitAllow: value?.isFreshLimitAllow || false,
        freshLimitAllow: value?.freshLimitAllow || null,
        remark: value?.remark,
      },
      marketAccess: [],
    };

    if (userSlice?.accountType === "broker") {
      delete obj.accountDetails;
      return obj;
    }
    let rentMarket = [];
    market?.forEach((scriptName) => {
      if (isRent) {
        rentMarket.push({
          scriptName: scriptName,
          isOnlyPositionSquareOff: false,
          status: true,
        });
      } else {
        const name =
          scriptName === "NSE EQU" || scriptName === "CRYPTO"
            ? "totalNoOfQuantity"
            : "totalNoOfLot";
        let remainingPercentage = isCustomer
          ? 0
          : userSlice?.accountType === "masterAdmin" || isRents
          ? 100 - value[scriptName]?.percentage
          : parentAccount?.brokarageDetails[scriptName]?.remainingPercentage -
            value[scriptName]?.percentage;
        const brokerageDetails = {
          deliveryTotal: value[scriptName]?.deliveryTotal || 0,
          intradayTotal: value[scriptName]?.intradayTotal || 0,
          deliveryBuy: isCustomer
            ? value[scriptName]?.deliveryBuy
            : value[scriptName]?.deliveryTotal / 2 || 0,
          intradayBuy: isCustomer
            ? value[scriptName]?.intradayBuy
            : value[scriptName]?.intradayTotal / 2 || 0,
          deliverySell: isCustomer
            ? value[scriptName]?.deliverySell
            : value[scriptName]?.deliveryTotal / 2 || 0,
          intradaySell: isCustomer
            ? value[scriptName]?.intradaySell
            : value[scriptName]?.intradayTotal / 2 || 0,
          percentage: isCustomer
            ? isRents
              ? 100
              : parentAccount?.brokarageDetails[scriptName]?.remainingPercentage
            : value[scriptName]?.percentage || 0,
          brokerageType: value?.[scriptName]?.brokerageType
            ? value?.[scriptName]?.brokerageType
            : ["NSE OPT", "MCX", "MCX OPT"]?.includes(scriptName)
            ? "fixed"
            : "percentage",
          remainingPercentage: remainingPercentage || 0,
        };

        const additionalSharing =
          convertBrokerId(value[scriptName]?.additionalSharing) || [];
        const margin = {
          type: "value",
          delivery: value[scriptName]?.delivery || 0,
          intraday: value[scriptName]?.intraday || 0,
          total: value[scriptName]?.total || 0,
          interestRate: value[scriptName]?.interestRate || 0,
          deposit: value[scriptName]?.deposit || 0,
        };
        const scriptWiseSettingInfo = {
          minimumScriptRate: value[scriptName]?.minimumScriptRate || null,
          totalNoOfScripts: value[scriptName]?.totalNoOfScripts || null,
          orderLimits: value[scriptName]?.orderLimits || null,
          strikeRateMaxLot: value[scriptName]?.strikeRateMaxLot || null,
          allowShortSell: value[scriptName]?.allowShortSell || false,
          allowLimitOrder: value[scriptName]?.allowLimitOrder || false,
          allowQuantityTrading:
            value[scriptName]?.allowQuantityTrading || false,
          [name]: value[scriptName]?.[name] || null,
          circuitFilter: value[scriptName]?.circuitFilter || 0,
          highLowPermission: value[scriptName]?.highLowPermission || false,
        };
        const isOnlyPositionSquareOff =
          value[scriptName]?.isOnlyPositionSquareOff || false;
        const allScript = blockedScriptList?.[scriptName]?.edited || [];
        const blockScript =
          filterBlockedScript(
            blockedScriptList?.[scriptName]?.blocked,
            blockedScriptList?.[scriptName]?.preBlock
          ) || [];
        const deletedScript = blockedScriptList?.[scriptName]?.deleted || [];

        let marketWisePayload = {
          brokerageDetails,
          additionalSharing,
          margin,
          scriptWiseSettingInfo,
          isOnlyPositionSquareOff,
          allScript,
          blockScript,
          deletedScript,
          scriptName: scriptName,
          status: true,
        };
        obj.marketAccess.push(marketWisePayload);
      }
    });
    if (isRent) {
      obj.marketAccess = rentMarket;
    }
    if (userSlice?.accountType === "broker") {
      obj.marketAccess = parentAccount?.parentMarketList;
    }

    return obj;
  }
};
